import App from './App';
import config from './config.json';

export default App;
export { config };